import React, {useState, useEffect} from 'react'
import { Button, Modal, Row, Col } from "reactstrap";

const ImportDetailsModal = ({config, modalDismiss}) => {
    
    const sections = [
        {
            name: 'Numery kont zespołu "5"', 
            columns: [
                {name: "Dodane", width: "6", data: config.details.opkAdded},
                {name: "Zaktualizowane", width: "6", data: config.details.opkUpdated}
            ]
        },
        {
            name: 'Numery kont zespołu "4"',
            columns: [
                {name: "Dodane", width: "3", data: config.details.fourAdded},
                {name: "Zaktualizowane", width: "3", data: config.details.fourUpdated},
                {name: "Systemowe (Nie podlegające modyfikacji)", width: "3", data: config.details.existingAnalyticCodes},
                {name: "Błędne", width: "3", data: config.details.wrongAnalyticCodes}
            ]
        }
    ]

    return(
        <Modal size="xl" isOpen={config.isShow}>
            <div className="modal-header">
                <button className="close" type="button" onClick={()=>modalDismiss()} >
                    <span>×</span>
                </button>
                <h5 className="modal-title text-center" id="exampleModalLabel" >
                    {config.name} - szczegóły importu
                </h5>
            </div>
            <div className="modal-body">
                { sections.map((section) => (
                    <div key={section.name} className="mb-4 pt-2 border-top">
                        <h3>{section.name}</h3>
                        <Row>
                            { section.columns.map((column) => (
                                <Col md={column.width} key={column.name}>
                                    <h5>{column.name}</h5>
                                    { column.data.length > 0 ? column.data.map((data, index) => (<p key={index}>{ data }</p>)): <p>-</p>}
                                </Col>
                            ))}
                        </Row>
                    </div>
                )) }
            </div>
            <div className="modal-footer">
                <div className="left-side">
                    <Button className="btn-link" color="default" type="button" onClick={() => modalDismiss()} >
                        Zamknij
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default ImportDetailsModal
